import { t } from "@lingui/macro";
import * as React from "react";
import { G, Path, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const MembershipIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 16" title={t`Membership`} {...props}>
    <G
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      clipPath="url(#a)"
    >
      <Path d="m3 3 1-2 1 2 2 1-2 1-1 2-1-2-2-1 2-1ZM8.5 8.5 10 5l1.5 3.5L15 10l-3.5 1.5L10 15l-1.5-3.5L5 10l3.5-1.5Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="none" d="M0 0h16v16H0z" />
      </ClipPath>
    </Defs>
  </Icon>
);
